import React from 'react'
import useTranslation from '../../hooks/useTranslation'
import SlideInView from '../../UI/SlideInView/SlideInView'
import Container from '../../UI/Container/Container'
import FullHeightContainer from '../../UI/FullHeightContainer/FullHeightContainer'
import Card from './Card'
import quickReactionImage from '../../../assets/image/advantages/time.svg'
import futureProofImage from '../../../assets/image/advantages/progress.svg'
import costPlanningImage from '../../../assets/image/advantages/cash.svg'
import FloatingHeadline from '../../UI/FloatingHeadline/FloatingHeadline'
import Headline from '../ui/Headline'
import Text from '../ui/Text'

function Advantages() {
  const t = useTranslation()
  const { kicker, heading, lead, items } = t.landing.advantages
  const advantageImages = [futureProofImage, quickReactionImage, costPlanningImage]

  return (
    <FullHeightContainer center id="leistungen">
      <div>
        <Container>
          <SlideInView>
            <div>
              {/* <FloatingHeadline text={kicker} /> */}
              <Headline headline={heading} size="xlarge" className="" />
              <Text text={lead} size="xlarge" className="mt-7" />
              <div className="mt-10 grid grid-cols-1 gap-10 md:gap-8 md:grid-cols-3">
                {items.map((item, index) => (
                  <Card key={item.title} icon={advantageImages[index] ?? quickReactionImage} title={item.title} description={item.text} />
                ))}
              </div>
            </div>
          </SlideInView>
        </Container>
      </div>
    </FullHeightContainer>
  )
}

export default Advantages
